<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div>
    <app-input-text [control]="form.get('countryPrefix')" name="port_number_countryPrefix" placeholder="" [autoFocus]="true"></app-input-text>
    <app-input-text [control]="form.get('areaCode')" name="port_number_areaCode" [placeholder]="areaCodePlaceholder"></app-input-text>
    <app-input-text [control]="form.get('number')" name="port_number_mainNumber" placeholder="port_number_mainnumber_placeholder"></app-input-text>
    <app-input-text [control]="form.get('previewNumber')" name="port_number_previewNumber" placeholder="port_number_previewnumber_placeholder"></app-input-text>
  </div>
  <div class="d-flex justify-content-end mt-3">
    <ng-content></ng-content>
    @if (!!submitButtonLabel) {
      <app-button-submit [invalid]="form.invalid" [label]="submitButtonLabel"></app-button-submit>
    }
  </div>
</form>
